import { IonApp, setupIonicReact } from '@ionic/react';
import AppContextProvider from "./providers/AppContextProvider";
import NavigationRouter from "./navigation/NavigationRouter";
import { IonReactRouter } from '@ionic/react-router';

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

// importing the global CSS files for ionic 
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

// Optional CSS ionic files
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

// Import custom CSS files
import "./theme/Map.css";
import "./theme/Modals.css";
import "./theme/Variables.css";
import "./theme/GlobalStyles.css";

// Import Bootstrap CSS and JS
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";

// function to set up ionic react
setupIonicReact();
const App: React.FC = () => {
  return (
    <AppContextProvider>
      <IonApp>
        <IonReactRouter>
          <NavigationRouter />
        </IonReactRouter>
      </IonApp>
    </AppContextProvider>
  );
};

export default App;
